import { render, staticRenderFns } from "./PainterHistory.vue?vue&type=template&id=0b548fb2&"
import script from "./PainterHistory.vue?vue&type=script&lang=js&"
export * from "./PainterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports